import 'vite/modulepreload-polyfill';
import TopMessageHandler from '@/library/topMessageHandler';
import axios from 'axios';
import {createApp, version} from 'vue';
import './directives';
import './filters';
import './init';
import App from './App.vue';
import {initVueApp} from './init';
import EditBlockHandler from './library/intranet/editBlockHandler';
import {installPresentationPointerBridge, installPresentationWindowLinkHandler} from './library/intranet/presentationWindow';
import './polyfill';
import store from './store';
import './stylesheet/global.scss';

// When running inside the Tauri desktop shell the app is served from a local
// origin, so chunk/asset URLs and XHR must be resolved against the remote
// intranet the shell connected to. The shell sets window.__intranetOrigin
// before this bundle executes; on the web it is undefined (relative origin).
const intranetOrigin = typeof window.__intranetOrigin === 'string' ? window.__intranetOrigin : '';

// @ts-ignore
window.__toCdnUrl = (filename) => intranetOrigin + '/dist/' + filename;

if (intranetOrigin)
{
    axios.defaults.baseURL = intranetOrigin;
    // The backend echoes the request origin and sets Access-Control-Allow-Credentials
    // (see Application/Module.php), so cookies only flow cross-origin with this enabled.
    axios.defaults.withCredentials = true;
}

installPresentationWindowLinkHandler();
installPresentationPointerBridge();

if (Array.isArray(axios.defaults.transformResponse))
{
    // commit _debug data to updateDebug if an axios request has finished
    axios.defaults.transformResponse.push((data) =>
    {
        if (typeof data === 'object' && data)
        {
            // check store.state.loggedIn to prevent endless redirect @ login mask, if any XHR is executed ...
            if (data.bookmarked > 0)
            {
                store.commit('bookmarkSetId', data.bookmarked);
                delete data.bookmarked;
            }

            if (data.blockManager)
            {
                for (let blockOptions of data.blockManager)
                {
                    new EditBlockHandler(blockOptions);
                }
            }

            if (data._debug)
            {
                store.commit('updateDebug', data._debug);
                delete data._debug;
            }
        }
        return data;
    });
}

if (process.env.NODE_ENV === 'development')
{
    console.info('Running Vue-Version: ' + version);

    if (import.meta.hot)
    {
        import.meta.hot.on('vite:afterUpdate', () => {
            TopMessageHandler.info('HMR calculated', null, 2);
        });
    }
}

// do NOT export/import a Vue instance!
const app = createApp(App);
initVueApp(app);
app.mount('#app');

